<template>
  <!--全局样式-->
</template>
<script>
export default {
    name: 'globalstyle',
  data(){
    return {

  	   }
    },
    props: {
    },
  mounted(){

  },
  methods:{

  }
}
</script>
<style lang="less">
  .el-divider--horizontal {
    border-top: 1px solid #dcdfe6;
    height: 0px;
    background-color:#fff;
    margin:16px 0px;
  }
  /*抽屉顶部样式*/
  .el-drawer__header {
    height: 50px;
    line-height: 50px;
    padding: 0px 0px 0px 20px;
    font-size: 14px;
    border-bottom: 1px solid #e2e2e2;
    margin-bottom: 10px;
  }
  .el-submenu__title {
    color: #515a6e;
  }
  .el-select-dropdown__item {
    font-size: 12px;
  }
  /*表格样式*/
 
  .el-table th {
    padding: 4px 0px !important;
    font-weight: bold !important;
    background: rgb(239, 242, 255) !important;
  }
  .el-table td {
    padding: 5px 0px !important;
  }
  .el-table thead {
    color: #6d7075 !important;
  }
  .el-table {
    font-size: 12px !important;
  }
  .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
    white-space: nowrap;
  }
  .el-card__header {
    padding: 10px 20px;
  }
  /*全局样式*/
  .global_style {
      .el-dialog__title

    {
      font-size: 14px;
    }
    /*弹出层内容*/
  .el-dialog__body {
    padding:15px;
  }

  .dialog-title {
    color: #777777;
    font-size: 12px;
  }
    /*弹出框头部和底部*/
    .el-dialog__header {
      padding: 10px 20px 10px;
      border-bottom: 1px solid #EBEEF5;
    }

    .el-dialog__headerbtn {
      top: 10px;
    }

    .el-dialog__footer {
      padding: 10px 20px 10px;
      border-top: 1px solid #EBEEF5;
    }
    /*按钮*/
    .el-button {
      border-radius: 3px;
      padding: 6px 10px;
    }

  }

  /*表格滚动条样式*/
  .el-table__body {
    padding-bottom: 8px; /*调整滚动条样式后，右边挺好列样式会有影响，故设置此值*/
  }
  .el-table__body-wrapper::-webkit-scrollbar {
    width: 8px !important;
    height: 8px !important;
  }

  .el-table__body-wrapper::-webkit-scrollbar-track {
    background: rgb(239, 239, 239) !important;
    border-radius: 0px !important;
  }

  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background: #bfbfbf !important;
    border-radius: 0px !important;
  }

    .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
      background: #778899 !important;
    }

  .el-table__body-wrapper::-webkit-scrollbar-corner {
    background: #179a16 !important;
  }
 

  /*编辑器样式*/
  .wangeditor {
    /* table 样式 */
    table

  {
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
  }

  table td,
  table th {
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    padding: 3px 5px;
  }

  table th {
    border-bottom: 2px solid #ccc;
    text-align: center;
  }

  /* blockquote 样式 */
  blockquote {
    display: block;
    border-left: 8px solid #d0e5f2;
    padding: 5px 10px;
    margin: 10px 0;
    line-height: 1.4;
    font-size: 100%;
    background-color: #f1f1f1;
  }

  /* code 样式 */
  code {
    display: inline-block;
    *display: inline;
    *zoom: 1;
    background-color: #f1f1f1;
    border-radius: 3px;
    padding: 3px 5px;
    margin: 0 3px;
  }

  pre code {
    display: block;
  }

  /* ul ol 样式 */
  ul, ol {
    margin: 10px 0 10px 20px;
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/globalstyle.vue